<template>
  <el-main style="padding-top: 0">
    <div style="width: 96%; margin: 0 auto">
      <div class="searchBox Cf">
        <!--搜索框-->
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            label="今天"
            name="today"
            :disabled="isDisabled"
          ></el-tab-pane>
          <el-tab-pane
            label="昨天"
            name="yesterday"
            :disabled="isDisabled"
          ></el-tab-pane>
          <el-tab-pane
            label="近三天"
            name="threedays"
            :disabled="isDisabled"
          ></el-tab-pane>
          <el-tab-pane
            label="本周"
            name="week"
            :disabled="isDisabled"
          ></el-tab-pane>
          <el-tab-pane
            label="上周"
            name="lastweek"
            :disabled="isDisabled"
          ></el-tab-pane>
          <el-tab-pane
            label="本月"
            name="mouth"
            :disabled="isDisabled"
          ></el-tab-pane>
          <el-tab-pane
            label="上月"
            name="lastmouth"
            :disabled="isDisabled"
          ></el-tab-pane>
          <el-tab-pane
            label="选择旬"
            name="xun"
            :disabled="isDisabled"
          ></el-tab-pane>
          <!-- <el-tab-pane
            label="选择时间段"
            name="selecttimes"
            :disabled="isDisabled"
          ></el-tab-pane> -->
        </el-tabs>

        <el-form
          :model="form"
          ref="form"
          label-width="80px"
          @submit.native.prevent
        >
          <el-form-item label="关键词:">
            <el-input
              v-model="form.key"
              placeholder="登录IP/操作"
              maxlength="120"
              size="mini"
              :disabled="isDisabled"
              @change="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="showXunSelect"
            label="年份:"
            label-width="60px"
            class="date_input"
          >
            <!-- <el-input
              v-model.number="form.year"
              placeholder="输入年份"
              @change="
                (value) => {
                  handleIsNumber(0, 1, value);
                }
              "
              size="mini"
              :disabled="isDisabled"
            ></el-input> -->
            <el-date-picker
              v-model="defaultYear"
              type="year"
              placeholder="选择年"
              @change="handleSelectTime"
              size="mini"
              style="width: 100px"
              format="yyyy"
              value-format="yyyy"
              key="year"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            v-if="showXunSelect"
            label="月份:"
            label-width="60px"
            class="date_input"
          >
            <el-date-picker
              v-model="defaultMonth"
              :clearable="false"
              type="month"
              @change="handleSelectTime"
              placeholder="选择月"
              key="month"
              size="mini"
              style="width: 100px"
              format="MM"
              value-format="MM"
            >
            </el-date-picker>
            <!-- <el-input
              v-model.number="form.month"
              placeholder="输入月份"
              @change="
                (value) => {
                  handleIsNumber(0, 2, value);
                }
              "
              :disabled="isDisabled"
              size="mini"

            ></el-input> -->
          </el-form-item>
          <el-tabs
            type="card"
            @tab-click="handleSelectXun"
            style="margin: 0 16px"
            v-if="showXunSelect"
            v-model="xunValue"
          >
            <el-tab-pane label="上旬" name="first"></el-tab-pane>
            <el-tab-pane label="中旬" name="middle"></el-tab-pane>
            <el-tab-pane label="下旬" name="end"></el-tab-pane>
          </el-tabs>
          <!-- <el-form-item class="buttons" label-width="0" v-if="showXunSelect">
            <el-button-group style="margin-left: 20px">
              <el-button
                plain
                size="mini"
                :disabled="form.year == '' || form.month == ''"
                @click="selectXun(1)"
                >上旬</el-button
              >
              <el-button
                plain
                size="mini"
                :disabled="form.year == '' || form.month == ''"
                @click="selectXun(2)"
                >中旬</el-button
              >
              <el-button
                plain
                size="mini"
                :disabled="form.year == '' || form.month == ''"
                @click="selectXun(3)"
                >下旬</el-button
              >
            </el-button-group>
          </el-form-item> -->

          <el-form-item
            label="选择时间段:"
            v-if="showTimeSelect"
            style="display: block; width: auto; margin-right: 20px"
            label-width="100px"
          >
            <el-date-picker
              v-model="dateValue"
              class="common-marginBottomRight10"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="margin-left: 10px"
              @change="
                (source) => {
                  logSelect(999);
                }
              "
              value-format="timestamp"
              align="left"
              size="mini"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label-width="20" style="width: 100px">
            <el-button
              type="primary"
              @click="search"
              size="mini"
              style="background-color: #1577d2"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <!-- <div class="xun_select" style="margin-bottom: 10px;" v-if="showXunSelect">
				<div style="font-size: 16px;font-family: Microsoft YaHei;">
					<span>选择旬：</span>
					<el-input placeholder="输入年份" v-model="xunForm.year" size="mini" style="width: 100px;"></el-input>
					<span style="margin-left: 10px;">年</span>
					<el-input placeholder="输入月份" v-model="xunForm.month" size="mini"
						style="width: 100px;margin-left: 10px;"></el-input>
					<span style="margin-left: 10px;">月</span>
					<el-button-group style="margin-left: 20px;">
						<el-button plain size="mini" :disabled="xunForm.year == '' || xunForm.month == ''"
							@click="selectXun(1)">上旬</el-button>
						<el-button plain size="mini" :disabled="xunForm.year == '' || xunForm.month == ''"
							@click="selectXun(2)">中旬</el-button>
						<el-button plain size="mini" :disabled="xunForm.year == '' || xunForm.month == ''"
							@click="selectXun(3)">下旬</el-button>
					</el-button-group>
				</div>
			</div> -->

      <div class="customerList">
        <div style="padding: 5px 10px">
          <div style="font-size: 16px; line-height: 20px; margin-bottom: 10px">
            选择坐席<span style="color: #a7a7a7">（不选默认所有）</span> ：
          </div>
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选
          </el-checkbox>
          <div style="margin: 15px 0"></div>
          <el-checkbox-group
            v-model="checkedList"
            @change="handleCheckedChange"
          >
            <el-checkbox
              style="width: 100px"
              v-for="customer in customerList"
              :label="customer.id"
              :key="customer.id"
              >{{ customer.realName }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <div>
        <el-table
          style="width: 100%; margin-top: 15px"
          :data="logLst"
          border
          highlight-current-row
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
          stripe
          :max-height="tableHeight"
        >
          <el-table-column property="userName" label="登录账号">
          </el-table-column>
          <el-table-column property="model" label="模块"> </el-table-column>
          <el-table-column property="option" label="具体操作">
          </el-table-column>
          <el-table-column property="ip" label="登录IP"> </el-table-column>
          <el-table-column property="createTime" label="时间">
          </el-table-column>
        </el-table>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          width: 60%;
          margin-left: 20%;
          justify-content: space-around;
          margin-top: 15px;
        "
      >
        <el-pagination
          background
          :pager-count="9"
          :page-size="10"
          layout="prev, pager, next, total"
          :total="total"
          @prev-click="pre"
          @next-click="next"
          @current-change="handleCurrentChange"
          :current-page="page"
        >
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      xunValue: "",
      input1: "",
      logLst: [],
      total: 0,
      page: 1,
      form: {
        key: "",
        startTime: "",
        endTime: "",
        year: "",
        month: "",
        xun: "",
      },
      threeXunIsDisabled1: true,
      threeXunIsDisabled2: true,
      isDisabled: false,
      dateValue: [
        new Date(new Date(new Date().toLocaleDateString()).getTime()),
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        ),
      ],
      startTime: "",
      endTime: "",
      keySearch: "",
      customerList: [],
      isIndeterminate: false,
      checkAll: false,
      checkedList: [],
      activeName: "today",
      value1: "",
      tableHeight: 400,
      showXunSelect: false,
      showTimeSelect: true,
      defaultYear: new Date().getFullYear().toString(),
      defaultMonth: (new Date().getMonth() + 1).toString(),
    };
  },
  mounted() {
    // const site = JSON.parse(localStorage.getItem("siteObj"));
    var start = new Date(new Date().toLocaleDateString()).getTime();
    this.form.startTime = this.util.timeStampToDate(start, 0);
    var end = Date.parse(new Date());
    this.form.endTime = this.util.timeStampToDate(end, 0);
    this.logSelect();
    this.getCurrentDepartBelowUsers();
    this.$nextTick(() => {
      var seaH = $(".searchBox").height();
      var cusH = $(".customerList").height();
      this.tableHeight = window.innerHeight - seaH - cusH - 180;
      window.addEventListener("resize", () => {
        //监听浏览器窗口大小改变
        //浏览器变化执行动作
        var seaH = $(".searchBox").height();
        var cusH = $(".customerList").height();
        this.tableHeight = window.innerHeight - seaH - cusH - 180;
      });
    });
  },
  watch: {
    value1: function (newVal) {
      console.log(111111111111, newVal);
    },
  },
  methods: {
    handleSelectTime() {
      if (this.xunValue !== "") {
        this.handleSelectXun();
      }
    },
    async logSelect(source) {
      if (source === 999) {
        this.activeName = "";
        this.page = 1;
        console.log(this.dateValue);
        if (this.dateValue === null) {
          this.dateValue = [];
          // this.form.startTime = new Date(new Date().toLocaleDateString());
          // this.form.endTime = new Date(
          //   new Date(new Date().toLocaleDateString()).getTime() +
          //     24 * 60 * 60 * 1000 -
          //     1
          // );
          // console.log(this.form.endTime.toLocaleString());
          // console.log(this.form.startTime.toLocaleString());
        } else {
          this.form.startTime = new Date(this.dateValue[0]);
          this.form.endTime = new Date(this.dateValue[1]);
        }
      }
      console.log(this.form.endTime.toLocaleString());
      console.log(this.form.startTime.toLocaleString());
      this.isDisabled = true;
      var api = "/manager/optionlog/selectCsStatusLog";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          current: this.page,
          size: 10,
          type: "ALL",
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          keySearch: this.form.key,
          csIds: this.checkedList,
        },
      });
      this.logLst = response.data.optionLogVoList;
      // if (this.logLst != null || this.logLst != []) {
      // 	for (var i = 0; i < this.logLst.length; i++) {
      // 		if (this.logLst[i].updateTime != null || this.logLst[i].updateTime != undefined) {
      // 			var end2 = this.util.timeStampToDate(this.logLst[i].updateTime, 0)
      // 			this.logLst[i].createTime = end2
      // 		} else {
      // 			if (this.logLst[i].createTime != null || this.logLst[i].createTime != undefined) {
      // 				var end1 = this.util.timeStampToDate(this.logLst[i].createTime, 0)
      // 				this.logLst[i].createTime = end1
      // 			}
      // 		}
      // 	}
      // }
      this.total = response.data.total;
      this.isDisabled = false;
      console.log(this.logLst);
    },
    async getCurrentDepartBelowUsers() {
      var api = "/manager/user/getCurrentDepartBelowUsers";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log(
        "reportStatistics getCurrentDepartBelowUsers response ===> ",
        response
      );

      if (response.resultCode === "10000") {
        this.customerList = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },
    headerStyle() {
      return "text-align:left;padding:15px;";
    },
    cellStyle() {
      return "text-align:left;padding:15px;";
    },
    pre(info) {
      console.log("pre：", info);
      this.page = info;
      this.logSelect();
    },
    next(info) {
      console.log("next：", info);
      this.page = info;
      this.logSelect();
    },
    handleCurrentChange(val) {
      console.log("当前页码：", val);
      this.page = val;
      this.logSelect();
    },
    search() {
      console.log("search", this.form);
      this.page = 1;
      // this.activeName = "";
      this.logSelect();
    },
    handleCheckAllChange(val) {
      if (val === true) {
        for (var i = 0; i < this.customerList.length; i++) {
          this.checkedList.push(this.customerList[i].id);
        }
      } else {
        this.checkedList = [];
      }
      this.logSelect();
    },
    handleCheckedChange() {
      this.page = 1;
      console.log(
        "LoggingManager handleCheckedChange checkedList",
        this.checkedList
      );
      this.logSelect();
    },
    handleClick(tab) {
      var name = tab.name;
      var start;
      var end;
      // this.dateValue = "";
      var now = new Date();
      var nowDayOfWeek = now.getDay(); //今天本周的第几天
      if (nowDayOfWeek === 0) {
        nowDayOfWeek = 7;
      }
      var nowDay = now.getDate(); //当前日
      var nowMonth = now.getMonth(); //当前月
      var nowYear = now.getYear(); //当前年
      nowYear += nowYear < 2000 ? 1900 : 0; //
      var lastMonthDate = new Date(); //上月日期
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      var lastMonth = lastMonthDate.getMonth();
      this.page = 1;
      if (name === "today") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        start = new Date(new Date().toLocaleDateString()).getTime();
        this.form.startTime = this.util.timeStampToDate(start, 0);
        end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        );
        this.form.endTime = this.util.timeStampToDate(end, 0);
        this.handleGetTime(this.form.startTime, this.form.endTime);
        this.logSelect();
      } else if (name === "yesterday") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        start =
          new Date(new Date().toLocaleDateString()).getTime() -
          24 * 60 * 60 * 1000;
        this.form.startTime = this.util.timeStampToDate(start, 0);
        end = new Date(new Date().toLocaleDateString()).getTime() - 1000;
        this.form.endTime = this.util.timeStampToDate(end, 0);
        console.log(
          "reportStatistics handleClick date",
          name,
          this.form.startTime,
          this.form.endTime
        );
        this.handleGetTime(this.form.startTime, this.form.endTime);
        this.logSelect();
      } else if (name === "week") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        start = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
        end = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 8);
        this.form.startTime = this.util.timeStampToDate(start, 0);
        // this.form.startTime = this.formatDate(start) + ' 00:00:00';
        // this.form.endTime = this.formatDate(end) + " 23:59:59";
        // console.log("start , end", this.form.startTime, this.form.endTime);
        end = new Date(new Date(end).getTime() - 1);
        this.form.endTime = this.util.timeStampToDate(end, 0);
        console.log(
          "reportStatistics handleClick date",
          name,
          this.form.startTime,
          this.form.endTime
        );
        this.handleGetTime(this.form.startTime, this.form.endTime);
        this.logSelect();
      } else if (name === "mouth") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        var monthStartDate = new Date(nowYear, nowMonth, 1);
        var monthEndDate = new Date(nowYear, nowMonth + 1, 1);
        var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24); //本月天数
        start = new Date(nowYear, nowMonth, 1);
        this.form.startTime = this.util.timeStampToDate(start, 0);

        // this.form.startTime = this.formatDate(start) + " 00:00:00";

        end = new Date(nowYear, nowMonth, days + 1);
        end = new Date(new Date(end).getTime() - 1);
        this.form.endTime = this.util.timeStampToDate(end, 0);
        // this.form.endTime = this.formatDate(end) + " 23:59:59"; //返回当月结束时间
        console.log(
          "reportStatistics handleClick date",
          name,
          this.form.startTime,
          this.form.endTime
        );
        this.handleGetTime(this.form.startTime, this.form.endTime);
        this.logSelect();
      } else if (name === "lastmouth") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        var lastMonthStartDate1 = new Date(nowYear, lastMonth, 1);
        var lastMonthEndDate1 = new Date(nowYear, lastMonth + 1, 1);
        var days1 =
          (lastMonthEndDate1 - lastMonthStartDate1) / (1000 * 60 * 60 * 24);
        start = new Date(nowYear, lastMonth, 1);
        this.form.startTime = this.formatDate(start) + " 00:00:00";
        end = new Date(nowYear, lastMonth, days1);
        this.form.endTime = this.formatDate(end) + " 23:59:59";
        console.log(
          "reportStatistics handleClick date",
          name,
          this.form.startTime,
          this.form.endTime
        );
        this.handleGetTime(this.form.startTime, this.form.endTime);
        this.logSelect();
      } else if (name == "threedays") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        start =
          new Date(new Date().toLocaleDateString()).getTime() -
          72 * 60 * 60 * 1000;
        this.form.startTime = this.util.timeStampToDate(start, 0);
        end = new Date(new Date().toLocaleDateString()).getTime() - 1000;
        this.form.endTime = this.util.timeStampToDate(end, 0);
        console.log(
          "reportStatistics handleClick date",
          name,
          this.form.startTime,
          this.form.endTime
        );
        this.handleGetTime(this.form.startTime, this.form.endTime);
        this.logSelect();
      } else if (name === "lastweek") {
        this.showXunSelect = false;
        this.showTimeSelect = true;
        start = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 6);
        this.form.startTime = this.util.timeStampToDate(start, 0);
        // this.form.startTime = this.formatDate(start) + " 00:00:00";
        end = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
        end = new Date(new Date(end).getTime() - 1);
        this.form.endTime = this.util.timeStampToDate(end, 0);

        // this.form.endTime = this.formatDate(end) + " 23:59:59";
        this.handleGetTime(this.form.startTime, this.form.endTime);
        this.logSelect();
      } else if (name === "xun") {
        this.showXunSelect = true;
        this.showTimeSelect = false;
      }
    },

    // 给时间选择器赋值
    handleGetTime(start, end) {
      if (this.dateValue === null) {
        this.dateValue = [];
      }
      this.dateValue.splice(
        0,
        2,
        new Date(start).getTime(),
        new Date(end).getTime()
      );
      console.log(this.dateValue);
    },
    formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },

    handleSelectXun() {
      if (this.xunValue == "first") {
        this.form.startTime =
          this.defaultYear + "-" + this.defaultMonth + "-" + "01" + " 00:00:00";
        this.form.endTime =
          this.defaultYear + "-" + this.defaultMonth + "-" + "10" + " 23:59:59";
      } else if (this.xunValue == "middle") {
        this.form.startTime =
          this.defaultYear + "-" + this.defaultMonth + "-" + "11" + " 00:00:00";
        this.form.endTime =
          this.defaultYear + "-" + this.defaultMonth + "-" + "20" + " 23:59:59";
      } else {
        let length = this.getMonthLength(this.defaultYear, this.defaultMonth);
        this.form.startTime =
          this.defaultYear + "-" + this.defaultMonth + "-" + "21" + " 00:00:00";
        this.form.endTime =
          this.defaultYear +
          "-" +
          this.defaultMonth +
          "-" +
          length +
          " 23:59:59";
      }
      console.log(this.form.startTime, this.form.endTime);
      this.logSelect();
    },
    getMonthLength(year, month) {
      return new Date(year, month, 0).getDate();
    },
    // 搜索功能
    handleSearch(value) {
      this.form.key = value;
    },
    // 判断是否为纯数字
    handleIsNumber(val1, val2, value) {
      var reg = /^[1-9][0-9]*$/;
      if (!reg.test(value)) {
        this.$message.error("请输入第一个数非0的纯数字");
        if (val1 === 0 && val2 === 1) {
          this.threeXunIsDisabled1 = true;
        } else if (val1 === 0 && val2 === 2) {
          this.threeXunIsDisabled2 = true;
        }
      } else {
        if (val1 === 0 && val2 === 1) {
          this.threeXunIsDisabled1 = false;
        } else if (val1 === 0 && val2 === 2) {
          this.threeXunIsDisabled2 = false;
        }
      }
      console.log(this.threeXunIsDisabled1, this.threeXunIsDisabled2);
    },
  },
};
</script>

<style lang="scss" scoped>
.timeTap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 15px;
  width: 90%;
}

.searchBox :deep() {
  .el-form-item {
    width: auto;
  }
  .el-tabs__item {
    min-width: 45px;
    height: 28px;
    line-height: 30px;
    padding: 0 10px !important;
    text-align: center;
    @include change_size($font_size_normal);
  }
  .el-tabs__item.is-active {
    border-bottom-color: #1577d2 !important;
    background-color: #1577d2;
    color: #fff;
  }
  .el-tabs__header {
    border-bottom: 1px solid #ffffff !important;
    // width: 228px;
    margin: 0;
  }

  .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed !important;
    margin-top: 5px;
    // margin-right: 15px;
  }

  .el-tabs,
  .el-tabs--card,
  .el-tabs--top {
    // width: 227px;
    float: left;
  }

  .el-form-item {
    min-width: 0 !important;
    
  }
  .buttons {
    width: 200px;
  }
}

.inputCss :deep() {
  .el-input__inner {
  }

  .el-input--suffix .el-input__inner {
    padding-right: 5px;
  }
}

.customerList {
  max-height: 140px;
  overflow: auto;
  border: 1px solid #ffffff;
  box-shadow: 0px 0px 4px 0px #d3d4de;
  // padding: 5px 10px;
  width: 100%;
}

.date_input :deep() {
  width: 160px !important;
  .el-form-item__content {
    width: 100px;
    margin-right: 10px;
  }
}
</style>
